/* eslint-disable import/no-cycle*/
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { addGiftOptions } from 'modules/clients/actions';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { ENABLE_GIFT_RECEIPT } from 'constants/featureToggleNames';
import { BRAND_PROFILES } from 'constants/index';
import GiftOptions from './GiftOptions';
import styles from './GiftOptions.styles';

const mapStateToProps = ({ user: { data } }) => ({
  isBGAssociate: data.brand === BRAND_PROFILES.BG,
});

const mapDispatchToProps = {
  addGiftOptions,
};

export default compose(
  withFeatureToggles({
    isGiftReceiptEnabled: ENABLE_GIFT_RECEIPT,
  }),
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(GiftOptions);
